import React from 'react'

interface CloudProps {
  width?: number
  height?: number
  className?: string
}

const Cloud: React.FC<CloudProps> = ({ width = 722, height = 521, className }) => {
  return (
    <svg
      width={width}
      height={height}
      // viewBox={`0 0 ${width} ${height}`}
      viewBox={`0 0 722 521`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M721.963 342.642V341.65C722.828 296.917 706.259 253.65 675.97 220.849C645.682 188.049 603.734 168.101 559.007 165.386C549.926 119.46 525.413 78.0425 489.422 47.9655C480.868 40.8151 471.777 34.4208 462.276 28.8007C432.68 10.7745 398.357 0.381376 361.746 0.180984C361.601 0.180984 361.464 0.171875 361.318 0.171875C361.209 0.171875 361.1 0.171875 360.999 0.171875C360.89 0.171875 360.781 0.171875 360.681 0.171875C360.535 0.171875 360.398 0.180984 360.253 0.180984C323.642 0.381376 289.319 10.7653 259.723 28.7824C250.222 34.4025 241.131 40.7969 232.577 47.9472C196.596 78.0334 172.073 119.451 162.991 165.368C118.256 168.082 76.3078 188.031 46.0286 220.831C15.7403 253.641 -0.829468 296.917 0.0359115 341.641V342.633C-0.428661 365.824 3.88002 388.888 12.5611 410.357C21.2423 431.826 34.1683 451.446 50.6014 467.806C67.0345 484.174 86.583 497.163 108.063 505.844C129.533 514.588 152.662 518.833 175.854 518.505C198.354 518.505 250.058 518.842 308.157 519.297L308.904 520.163C325.856 520.017 343.41 519.871 360.999 519.726C378.589 519.871 396.152 520.017 413.095 520.163L413.842 519.297C471.941 518.851 523.645 518.505 546.145 518.505C569.337 518.833 592.466 514.597 613.936 505.844C635.407 497.163 654.955 484.174 671.398 467.806C687.831 451.437 700.757 431.826 709.438 410.357C718.119 388.888 722.428 365.824 721.963 342.633V342.642Z"
        fill="#DAEFE6"
      />
    </svg>
  )
}

export default Cloud
